import { AuthActionPayload } from "../redux/auth-slice/types";

// global variable to control if the register modal should be shown
let shouldShowRegisterModal = true;

export const checkRegisterModal = (data:AuthActionPayload) => {
    if (data.showRegisterModal && shouldShowRegisterModal) {
        const registerModal = document.createElement('tm-register-modal');
        document.body.appendChild(registerModal);
    }
};

// function to control if the register modal should be shown
export const setShouldShowRegisterModal = (show: boolean) => {
    shouldShowRegisterModal = show;
};

// function to check if register modal should be shown
export const getShouldShowRegisterModal = () => {
    return shouldShowRegisterModal;
};